import React from 'react'

const About = () => {
  return (
    <section id="about" className="py-3">
    <div className="container">
    <h2 className="fw-bold">About me</h2>
    <p>
    Hello there! My name is Salman Saeed, an aspiring Financial Analyst with a strong focus on leveraging data and technology to deliver meaningful insights and solutions in the financial services sector. With a Distinction in MSc in Financial Analysis and Fund Management (First Class Honours) from the University of Exeter, I specialize in financial modelling, advanced analytics, and risk management.
    </p>
    <p>
    Eager to apply my analytical skills and proactive approach in entry-level or associate roles within the financial services sector. Proficient in tools like Excel VBA, Power BI, Tableau, SQL and Python. As a CFA Level 1 candidate, I am committed to growing my expertise and contributing to forward-thinking teams that shape the future of finance through analytics, technology, and innovative problem-solving.  
    </p>
  </div>
    </section>
  )
}

export default About
